import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import QRCode from "react-qr-code";
import notFoundImg from "../../../../assets/img/notFound.jpg";
import { isMaderasPath, URLAPI } from "../../../../Helpers/apimaderas";
import { useTranslation } from "react-i18next";
import HeaderFour from "../../headers/HeaderFour";

export default function QrMaderas() {
  const { t } = useTranslation();
  const { token: tokenAsesor } = useParams();
  const { pathname } = useLocation();
  const isLivingMaderas = isMaderasPath(pathname);
  const [profileInfo, setProfileInfo] = useState();
  const [config, setConfig] = useState({});

  const fetchGetConfig = async () => {
    try {
      const resp = await fetch(`${URLAPI(pathname)}/config/get`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({}),
      }).then((resp) => resp.json());
      if (resp.success) {
        setConfig(resp.data);
        document.documentElement.style.setProperty(
          "--background-image",
          `url(${resp.data.background})`,
        );
      } else {
        throw new Error(resp.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const fetchAPI = async () => {
      try {
        await fetchGetConfig();

        const resp = await fetch(`${URLAPI(pathname)}/seller/profile`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            token: tokenAsesor,
          }),
        }).then((resp) => resp.json());
        if (resp.success) {
          setProfileInfo(resp);
        } else {
          throw new Error(resp.message);
        }
      } catch (error) {
        console.log("error: ", error);
      }
    };

    fetchAPI();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [theme, setTheme] = useState(() => {
    return localStorage.getItem("maderas-theme") || "dark";
  });

  const toggleTheme = () => {
    const newTheme = theme === "dark" ? "light" : "dark";
    setTheme(newTheme);
    localStorage.setItem("maderas-theme", newTheme);
  };

  useEffect(() => {
    if (theme === "dark") {
      document.body.classList.add("dark-theme");
    } else {
      document.body.classList.remove("dark-theme");
    }
  }, [theme]);

  const { perfil = {}, vendedor = {} } = profileInfo?.data || {};
  return (
    Object.values(perfil).length > 0 && (
      <div
        className={`visible_converter maderas-elegant qr-view-container ${theme === "light" ? "light-theme" : ""}`}
      >
        <div className="living-background-overlay" aria-hidden="true"></div>

        <main className="qr-content-wrapper">
          <HeaderFour
            logo={config?.logo}
            isLivingMaderas={isLivingMaderas}
            theme={theme}
            toggleTheme={toggleTheme}
          />

          <section
            className="bostami-parsonal-info-area"
            aria-labelledby="qr-advisor-name"
          >
            <div className="elegant-curve-bg" aria-hidden="true"></div>
            <div className="elegant-curve-bg-2" aria-hidden="true"></div>

            <div className="bostami-parsonal-info-wrap">
              <div className="bostami-parsonal-info-img">
                <img
                  src={perfil.urlFoto || notFoundImg}
                  alt={`${t("app.asesor")} ${vendedor.nombre}`}
                />
              </div>

              <h1
                id="qr-advisor-name"
                className="bostami-parsonal-info-name"
              >
                <span>{vendedor.nombre}</span>
              </h1>

              <span className="bostami-parsonal-info-bio">
                {t("app.asesor")}
              </span>

              <div
                className="qr-code-container"
                role="img"
                aria-label={`${t("app.codigoQr")}: ${vendedor.nombre}`}
              >
                <QRCode
                  size={200}
                  value={window.location.href.replace("qr/", "")}
                  viewBox={`0 0 256 256`}
                  className="qr-code-canvas"
                  bgColor="transparent"
                  fgColor="#c5a059"
                  aria-hidden="true"
                />
              </div>

              <div className="bostami-parsonal-info-contact">
                <div className="bostami-parsonal-info-contact-item">
                  <div className="icon">
                    <i className="fa-regular fa-mobile" aria-hidden="true"></i>
                  </div>
                  <div className="text">
                    <span>{t("app.telefono")}</span>
                    <a href={`tel:${perfil.telefono}`}>{perfil.telefono}</a>
                  </div>
                </div>
                <div className="bostami-parsonal-info-contact-item">
                  <div className="icon">
                    <i
                      className="fa-regular fa-envelope-open-text"
                      aria-hidden="true"
                    ></i>
                  </div>
                  <div className="text">
                    <span>{t("app.correo")}</span>
                    <a href={`mailto:${perfil.email}`}>{perfil.email}</a>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>
    )
  );
}
